import axios from 'axios'
import lodash from 'lodash'
import qs from 'qs'

import store from '@/store'
import errorHandler from '@/errorHandler'
import { fileReader } from "@/helpers";

class ApiError extends Error {
  constructor(code, status, message) {
    super(message)
    this.code = code
    this.status = status
    this.message = message
  }
}


export default {

  install(Vue, config) {

    axios.interceptors.response.use(null, async error => {
      console.log(error.response)

      if (error.response.data) {
        let data
        if (error.response.request.responseType === 'blob') {
          const file = await fileReader(error.response.data);
          // Parse content and retrieve 'message'
          data = JSON.parse(file);
        } else {
          data = error.response.data
        }
        const { code, status, message } = data
        error = new ApiError(code, status, message)
      }
      errorHandler(error)
      return Promise.reject(error)
    })

    lodash.merge(axios.defaults, {

      baseURL: config.api.baseURL,

      paramsSerializer: params => qs.stringify(params),

      transformRequest: [(data, headers) => {
        const { token } = store.state.auth
        headers['Content-Type'] = 'application/json'
        if (token) {
          headers['Authorization'] = `Bearer ${token}`
        }
        return JSON.stringify(data)
      }],

      transformResponse: [data => {
        try {
          data = JSON.parse(data)
        } catch (e) {
        }
        return data ? data : null
      }],

    })


    Vue.prototype.$isApiError = error => {
      return error instanceof ApiError
    }

    Vue.prototype.$axios = axios
  }

}
